import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'

export default function PropertiesPaneRa(props) {
    return (
        <ArchPropertiesPane
            {...props}
        />
    )
}
